import * as React from "react"
import { Widget, mk_widget, any, AsyncState } from "widgets-for-react"
import { styleguideChapter, styleguideSection, styleguidePart, styleguideExample} from "../helpers";
import { primaryHeaderBlock, secondaryHeaderBlock } from "../../components/public_site/blocks/custom_blocks/widgets/headerBlock.mod";
import { CMSState } from "../../components/cms/blocks/types.gen";
import { PublicSiteState, HeaderState } from "../../components/public_site.main.mod";
import { GridBlock } from "../../components/public_site/blocks/custom_blocks/widgets/gridBlock.mod";
import { placeholderImage } from "../../components/public_site/utils/extra_images.mod";
import { header } from "../../components/public_site/templates/header.mod";
import { WordPress } from "../../components/wordpress/wordpress_api";
import { QuoteBlock } from "../../components/public_site/blocks/custom_blocks/widgets/quoteBlock";
import { FeaturedContentBlock } from "../../components/public_site/blocks/custom_blocks/widgets/featuredContentBlock";
import { TextBlock } from "../../components/public_site/blocks/custom_blocks/widgets/textBlock";
import { footer } from "../../components/public_site/templates/footer.mod";
import { AppState } from "../../components/cms/state/types.gen";
import { PublicSiteCustomRoutes } from "../../components/public_site/custom_pages/types.mod";

export const compositionHomepage: Widget<never> = mk_widget({
  run: (_) =>
    styleguideSection({type: "components", slug: "composition-homepage", title: "Page example"})(
      any()([
        styleguidePart({extraClasses: "page"})(
          any()([
            header({} as HeaderState, {} as AsyncState<WordPress.OptionsResponse>),
            primaryHeaderBlock({
              blockName: "vidda/header",
              header_type: "header one",
              title: "Hallo, wij zijn Dubbeldam",
              intro:
                "Uw partner die ervoor zorgt dat uw voertuigen inzetbaar blijven. Wilt u een carrosserie laten bouwen of een voertuig laten bewerken, keuren of herstellen tot nieuwstaat? Met 208 man staan we voor u klaar",
              primary_button: {
                text: "Over Dubbeldam",
                url: "",
              },
            })({} as CMSState<{}, {}, never>)({} as PublicSiteState),
            GridBlock({
              blockName: "vidda/grid",
              title: "Van schadeherstel tot maatwerk carrosserieën, spuitwerk en keuringen. Wij helpen u op weg.",
              intro: "Heeft u een uitdagend vervoersprobleem? Wij helpen u graag. Wij denken graag mee om voor u de juiste oplossing te vinden. Of dat nu een maatwerk carrosserie is of een van onze standaard producten. U kunt natuurlijk ook voor reparatie, onderhoud en schadeherstel bij ons terecht.",
              primary_button: {
                text: "Bekijk meer",
                url: "",
              },
              blocks: [
                {
                  title:
                    "Etiam porta sem malesuada magna moll",
                  intro:
                    "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada",
                   link: {
                    is_link_external: false,
                    kind: "link",
                    target: "_blank",
                    url: "",
                    title: "Read me",
                  },
                  image: placeholderImage(""),
                },
                {
                  image: placeholderImage(""),
                  title: "Elektrische voertuigen",
                  intro:
                    "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.",
                },
                {
                  title: "Cursus Aenean Tortor Cursus Aenean Tortor Cursus Aenean Tortor",
                  intro: "Praesent commodo cursus magna, vel scelerisque.",
                  link: {
                    is_link_external: false,
                    kind: "link",
                    target: "_blank",
                    url: "",
                    title: "Amet Justo Fusce Tortor Vestibulum",
                  },
                  image: placeholderImage(""),
                },
                {
                  image: placeholderImage(""),
                  title: "Ligula Vestibulum Euismod Ridiculus Consectetur",
                  intro:
                    "Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Etiam porta sem malesuada magna mollis euismod.",
                },
                {
                  image: placeholderImage(""),
                  title: "Cursus Aenean Tortor Cursus Aenean Tortor Cursus Aenean Tortor",
                  intro: "Praesent commodo cursus magna, vel scelerisque.",
                  link: {
                    is_link_external: false,
                    kind: "link",
                    target: "_blank",
                    url: "",
                    title: "Amet Justo Fusce Tortor Vestibulum",
                  },
                },
              ],
            })({} as CMSState<{}, {}, never>)({} as PublicSiteState),
            QuoteBlock({
              index: 0,
              text:
                "Bij ons staat ‘de mens’ centraal.  Niet alleen onze klanten, maar ook onze werknemers. Dankzij hen leveren wij altijd de beste kwaliteit.",
              author: "Roel van Neerbos",
              company: "Managing director",
            })({} as CMSState<{}, {}, never>),
            footer({} as AppState<PublicSiteState, PublicSiteCustomRoutes>)
          ]) // end composition
        ),
      ])
    ).run(_),
});

export const compositionOverviewPage: Widget<never> = mk_widget({
  run: (_) =>
    styleguideSection({type: "components", slug: "composition-overview", title: "Overview page example"})(
      any()([
        styleguidePart({extraClasses: "block--grid-info"})(
          any()([
            header({} as HeaderState, {} as AsyncState<WordPress.OptionsResponse>),
            primaryHeaderBlock({
              blockName: "vidda/header",
              header_type: "header one",
              title: "Werken bij Dubbeldam",
              intro: "Wij zijn een dynamische organisatie met een prettige werksfeer. We hechten veel waarde aan de ontwikkeling van onze medewerkers. Leer meer over ons als werkgever en ontdek onze vacatures.",
              primary_button: {
                text: "Dubbeldam als werkgever",
                url: "",
              },
            })({} as CMSState<{}, {}, never>)({} as PublicSiteState),
            GridBlock({
              blockName: "vidda/grid",
              title: "",
              intro: "",
              blocks: [
                {
                  title:
                    "International account manager.",
                  intro: "Een uitdagende internationale functie voor een resultaat gedreven verkoper met een...",
                  link: {
                    is_link_external: false,
                    kind: "link",
                    target: "_blank",
                    url: "",
                    title: "Bekijk vacature",
                  },
                  image: placeholderImage(""),
                },
                {
                  title:
                    "International account manager.",
                  intro: "Een uitdagende internationale functie voor een resultaat gedreven verkoper met een...",
                  link: {
                    is_link_external: false,
                    kind: "link",
                    target: "_blank",
                    url: "",
                    title: "Bekijk vacature",
                  },
                  image: placeholderImage(""),
                },
                {
                  title:
                    "International account manager.",
                  intro: "Een uitdagende internationale functie voor een resultaat gedreven verkoper met een...",
                  link: {
                    is_link_external: false,
                    kind: "link",
                    target: "_blank",
                    url: "",
                    title: "Bekijk vacature",
                  },
                  image: placeholderImage(""),
                },
                {
                  title:
                    "International account manager.",
                  intro: "Een uitdagende internationale functie voor een resultaat gedreven verkoper met een...",
                  link: {
                    is_link_external: false,
                    kind: "link",
                    target: "_blank",
                    url: "",
                    title: "Bekijk vacature",
                  },
                  image: placeholderImage(""),
                },
                {
                  title:
                    "International account manager.",
                  intro: "Een uitdagende internationale functie voor een resultaat gedreven verkoper met een...",
                  link: {
                    is_link_external: false,
                    kind: "link",
                    target: "_blank",
                    url: "",
                    title: "Bekijk vacature",
                  },
                  image: placeholderImage(""),
                },
                {
                  title:
                    "International account manager.",
                  intro: "Een uitdagende internationale functie voor een resultaat gedreven verkoper met een...",
                  link: {
                    is_link_external: false,
                    kind: "link",
                    target: "_blank",
                    url: "",
                    title: "Bekijk vacature",
                  },
                  image: placeholderImage(""),
                },
              ],
            })({} as CMSState<{}, {}, never>)({} as PublicSiteState),
            QuoteBlock({
              index: 0,
              text:"Hier kan een pakkende quote van een medewerker die enthousiast vertelt hoe het is om bij Dubbeldam te werken.",
              author: "Willem Werknemer",
              company: "Werkplaatsmedewerker",
            })({} as CMSState<{}, {}, never>),
            FeaturedContentBlock({
              blockName: "vidda/featured-content",
              title: "Dubbeldam als werkgever",
              intro:'Hier een stukje over dat er goed voor de medewerkers wordt gezorgd. Hierin kun je ook een aantal pluspunten noemen, zoals leermeesters, opleindings- of ontwikkelingstrajecten, jullie eigen app en jullie maatschappelijke betrokkenheid. Hier kun je op een andere pagina meer over uitwijden.',
              button: {
                text: "Dubbeldam als werkgever",
                url: "/"
              },
              image_position: "left",
              image: placeholderImage("Donec ullamcorper nulla non metus auctor fringilla")
            })({} as CMSState<{}, {}, never>)({} as PublicSiteState),
            footer({} as AppState<PublicSiteState, PublicSiteCustomRoutes>)
          ]) // end composition
        ),
      ])
    ).run(_),
});

export const compositionDetailPage: Widget<never> = mk_widget({
  run: (_) =>
    styleguideSection({type: "components", slug: "composition-detail", title: "Detail page example"})(
      any()([
        styleguidePart({extraClasses: "page--detail"})(
          any()([
            header({} as HeaderState, {} as AsyncState<WordPress.OptionsResponse>),
            secondaryHeaderBlock({
              blockName: 'vidda/header',
              header_type: "header two",
              title: "Hallo, wij zijn Dubbeldam",
              intro: "Uw partner die ervoor zorgt dat uw voertuigen inzetbaar blijven. Wilt u een carrosserie laten bouwen of een voertuig laten bewerken, keuren of herstellen tot nieuwstaat? Met 208 man staan we voor u klaar"
             })({} as CMSState<{}, {}, never>)({} as PublicSiteState),
             TextBlock({
              has_show_more: false,
              text: 
              "<h3>Wat ga je doen?</h3><p>Donec id elit non mi porta gravida at eget metus. Donec sed odio dui. Donec id elit non mi porta gravida at eget metus. Donec sed odio dui.</p><h3>H3 Ullamcorper Dolor Ligula</h3><p>Integer posuere erat a ante venenatis dapibus posuere velit aliquet. <a>Etiam porta sem malesuada magna mollis euismod.</a> Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Aenean lacinia bibendum nulla sed consectetur.</p><blockquote class='wp-block-quote'><p>Maecenas sed diam eget risus varius blandit sit amet non magna. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Etiam porta sem malesuada magna mollis euismod.</p><cite>Commodo Ipsum Cras Amet</cite></blockquote><h4>H4 Condimentum Magna Fermentum Egestas Vestibulum</h4><ul><li>Sed posuere consectetur est at lobortis. Donec ullamcorper nulla non metus auctor fringilla.</li><li>Tristique Lorem<ol><li>Donec ullamcorper nulla non metus auctor fringilla. </li><li>Donec id elit non mi porta gravida at eget metus. </li><li>Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Sed posuere consectetur est at lobortis.</li></ol></li><li>Aenean lacinia bibendum nulla sed consectetur. Vestibulum id ligula porta felis euismod semper.<ul><li>Tristique Lorem</li></ul><ul><li>Donec ullamcorper nulla non metus auctor fringilla. Donec id elit non mi porta gravida at eget metus. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Sed posuere consectetur est at lobortis.</li></ul></li><li>Aenean lacinia bibendum nulla sed consectetur. Vestibulum id ligula porta felis euismod semper.</li></ul><ol><li>Aenean lacinia bibendum nulla sed consectetur. Vestibulum id ligula porta felis euismod semper.</li><li> Vestibulum id ligula<ol><li>Sed posuere consectetur est at lobortis. Donec ollamcorper nulla non metus auctor fringilla.</li><li>Tristique Lorem</li><li>Aenean lacinia bibendum nulla sed consectetur. Vestibulum id ligula porta felis euismod semper.</li></ol></li><li>Aenean lacinia bibendum nulla sed consectetur. Vestibulum id ligula porta felis euismod semper.<ul><li>Tristique Lorem</li><li>Donec ullamcorper nulla non metus auctor fringilla. Donec id elit non mi porta gravida at eget metus. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Sed posuere consectetur est at lobortis.</li></ul></li><li>Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.</li></ol>"
             })({} as CMSState<{}, {}, never>),
             footer({} as AppState<PublicSiteState, PublicSiteCustomRoutes>)

          ]) // end composition
        ),
      ])
    ).run(_),
});

export const styleguideCompositions: Widget<never> = mk_widget({
  run: (_) =>
    any()([
      styleguideChapter({type: "compositions", slug: "compositions", title: ""})(
        any()([
          compositionHomepage,
          compositionOverviewPage,
          compositionDetailPage
        ])
      ),
    ]).run(_),
});
